// Global JQuery Functions
var globaljs = globaljs || {};

// MISC
handleize = function(str) {
    str = str.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    };

    str = str.replace(/\W+/g, "-");
    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    };
    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    };
    return str;
};
urlParam = function(name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null){
      return null;
  } else {
      return results[1] || 0;
  };
};

// IFRAME CHECK
function iframe_loaded(iframe) {
  if(iframe) {
    iframe.height = "";
    iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
  };
};

// COOKIES
function cookie_make(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  } else { var expires = ""; };
  document.cookie = name+"="+value+expires+"; path=/; domain=marketplace.fullfactorydistro.com";
};
function cookie_get(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  };
  return "";
};
function cookie_check(cname) {
  var cookie = cookie_get(cname);
  if (cookie!="") {
    return cookie;
  } else{ return false; }
};

// STRIP HTML
function stripHtml(html) {  if (!html) return "";  const tmp = document.createElement("div");  tmp.innerHTML = html;  return tmp.textContent || tmp.innerText || "";}

// RSS Reader
(function () {

  async function fetchJson(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  async function renderWpFeed(el) {
    const site = el.dataset.site;
    const tagSlug = el.dataset.tagSlug || "";
    const perPage = el.dataset.perPage || "10";

    if (!site) {
      //el.innerHTML = "<p>Missing data-site.</p>";
      return;
    }

    let tagParam = "";

    // 🔍 Convert tag slug → tag ID
    if (tagSlug) {
      const tagUrl = site.replace(/\/$/, "") + "/wp-json/wp/v2/tags?slug=" + tagSlug;
      const tags = await fetchJson(tagUrl);

      if (!tags.length) {
        //el.innerHTML = "<p>No posts for tag: " + tagSlug + "</p>";
        return;
      }

      tagParam = "&tags=" + tags[0].id;
    }

    // 📰 Fetch posts
    const postsUrl =
      site.replace(/\/$/, "") +
      "/wp-json/wp/v2/posts?per_page=" +
      perPage +
      "&_embed=1" +
      tagParam;

    const posts = await fetchJson(postsUrl);

    if (!posts.length) {
      //el.innerHTML = "<p>No posts found.</p>";
      return;
    }

    let html = `
      <div class="wp-embed-feed-grid spacer-top border-dark product-news">
        <h3><a href="https://fairdalebikes.com/tag/${tagSlug}/">Fairdale News &raquo;</a></h3>
        <div class="grid row has_spacing total-4">
          `;

    posts.forEach(post => {
      const title = post.title.rendered;
      const link = post.link;
      const excerpt_raw = post.excerpt.rendered;
      const excerpt = stripHtml(excerpt_raw);

      let img = "";
      if (post.feed_image) { 
        img = post.feed_image;
      } else {
        const media = post._embedded?.["wp:featuredmedia"]?.[0];
        if (media) {
          img = media.media_details?.sizes?.medium_large?.source_url ||
                media.media_details?.sizes?.medium?.source_url ||
                media.source_url;
        }
      }

      html += `
        <div class="wp-feed-post col col25 col-maxwidth50">
          <a href="${link}" class="wp-feed-img-wrap">
            <span class="img preserve-aspect ratio-3x2" style="background-image:url(${img}" class="wp-feed-img">&nbsp;</span>
            <span class="info">
              <span class="title wp-feed-title">${title}</span>
              <span class="excerpt wp-feed-excerpt">${excerpt}</span>
            </span>
          </a>
        </div>
      `;
    });

    html += `
        </div>
      </div>`;
    el.innerHTML = html;
  }

  function init_feeds() {
    const feeds = document.querySelectorAll(".wp-embed-feed");
    feeds.forEach(renderWpFeed);
  }
  document.addEventListener("DOMContentLoaded", init_feeds);
})();

// JQUERY
jQuery(document).ready(function($) {
  
  var html_dom = $('html'),
      body_dom = $('body'),
      ff_link = $('#ff-link'),
      brands_link = $('#brands-link'),
      url_anchor = window.location.hash.slice(1);
  
  html_dom.removeClass('no-js');
  body_dom.addClass('js-initiated');

  // Toggles
  $('.js-hide').each(function(){
    $(this).removeClass('js-hide').addClass('hide');
    /*
    var hide_id = $(this).attr('id');
    if($(this).attr('id')){
      body_dom.addClass('hide-'+hide_id);
    };
    */
  });
  $('a.btn-toggle').click(function(e){
    var btn = $(this),
        hide_btn_class = 'hide-'+btn.attr('data-target'),
        show_btn_class = 'show-'+btn.attr('data-target');

    if (btn.attr('href').indexOf("#") >= 0) {
    } else { e.preventDefault(); };
  
    if(body_dom.hasClass(show_btn_class) || btn.find('span.close').first().is(":visible")) {
      body_dom.removeClass(show_btn_class);
      body_dom.addClass(hide_btn_class);
      btn.removeClass('show-target');
      btn.addClass('hide-target');
    } else {
      body_dom.addClass(show_btn_class);      
      body_dom.removeClass(hide_btn_class);      
      btn.addClass('show-target');
      btn.removeClass('hide-target');
    };
  });

  $('a.section-toggle').click(function(e){
    var section_btn = $(this),
        section_content = $('#'+section_btn.attr('href').replace('#','')+' .section-content');

    e.preventDefault();
    
    if(section_content.hasClass('hide')) {
      section_btn.addClass('active')
      section_content.removeClass('hide');
    } else {
      section_btn.removeClass('active')
      section_content.addClass('hide');
    };
  });
  if(url_anchor) {
    // Find the element with the matching ID or name attribute
    var url_anchor_element = $("#" + url_anchor).length ? $("#" + url_anchor) : $("[name='" + url_anchor + "']");

    if (url_anchor_element.length) {

      // If page has sections
      $('#'+url_anchor+' a.section-toggle').addClass('active');
      $('#'+url_anchor+' .section-content').removeClass('hide');

      if($('#'+url_anchor+' .section-content').length) {
        $("html, body").animate({
          scrollTop: url_anchor_element.offset().top+25
        }, 500);

      } else {
        $("html, body").animate({
          scrollTop: url_anchor_element.offset().top-150
        }, 500);
      };
    };
  };
    
  var search_forms = $('.search-form');
  search_forms.each(function(){
    var search_form = $(this),
      search_input = search_form.find('.search-input'),
      search_submit = search_form.find('.search-submit'),
      search_action = function(e) {
        e.preventDefault();
        window.parent.location = search_submit.attr('href')+search_input.val();
      };
      search_submit.click(function(e){
        search_action(e);
      });
      search_input.bind("enterKey",search_action);
      search_input.keyup(function(e){
        if(e.keyCode == 13) {
          $(this).trigger("enterKey");
        };
      });
  });

  
  
  // FANCYBOX
  var fancybox_settings = {
    loop: true,
    margin: [50,10], // ignored if zoomed-in or viewport width is smaller than 800px
    gutter: 0, // horizontal space between slides
    infobar: false,
    buttons: [
      'download',
      'fullScreen',
      'thumbs',
      'close'
    ],
    animationEffect: false,
  };
  $('.post').each(function(){ fancybox_auto($(this)) }); 
  fancybox_auto(html_dom); 
  function fancybox_auto(container) {
    var links = container.find("a[href$='.jpg'],a[href$='.png'],a[href$='.gif']").not('.nolightbox, .fancybox, .slick-cloned a');
        
    links.each(function(){
      var link = $(this),
          href = link.attr('href');
      
      link.addClass('fancybox');
      link.attr('href',href.replace(/-\d+[Xx]\d+\./,'.'));
      if(container.attr('id')) {
        links.attr('data-fancybox','gallery-'+container.attr('id').replace('post-',''));
      };
    });
  };
    
  // Activate Lightbox
  $('a[rel=instagram-sc-images]').fancybox(fancybox_settings);
  $('a[rel=lightbox]').fancybox(fancybox_settings);
  $('a[rel=lightbox]').fancybox(fancybox_settings);
  $('a.fancybox').fancybox(fancybox_settings);
    
  // WIDOWS
  $(".nowidows").each(function() {
    var wordArray = $(this).text().split(" "),
        three = false;
    if (wordArray.length > 1) {
      if(wordArray[wordArray.length-2].length<3){ three=true }

      wordArray[wordArray.length-2] += '<span class="widow">&nbsp;</span>' + wordArray[wordArray.length-1];
      wordArray.pop();

      if(three) {
        wordArray[wordArray.length-2] += '<span class="widow">&nbsp;</span>' + wordArray[wordArray.length-1];
        wordArray.pop();
      };
      $(this).html(wordArray.join(" "));
    };
  });
  
  // iFrames
  $('#content .entry iframe').each(function(){
  	var iframe = $(this),
        iframe_parent = iframe.parent('p'),
        aspect = 'ratio-3x2';
    
    if(iframe.attr('src').indexOf("youtube") >= 0 || iframe.attr('src').indexOf("vimeo") >= 0){
       aspect = 'ratio-16x9';      
    };
    if(iframe.attr('src').indexOf("instagram") >= 0){
      aspect = '';
      iframe.wrap('<p class="instagram-embed-rendered"></p>');

      /*
      var iframe_loading = true;      
      iframe.on('load', function() {
        var iframe_contents = iframe.contents();
        iframe_contents.ready(function() {
          if(iframe_loading) {
            iframe_loading = false;
            var iframe_height = iframe.height(),
                iframe_width = iframe.width(),
                height_ratio = Math.round((iframe_height-267.75)/iframe_width*100);
            //console.log(height_ratio+':'+iframe_height+'/'+iframe_width);
            //iframe_aspect(iframe,iframe_parent,'instagram-embed-rendered height-ratio-'+height_ratio);
            //iframe_aspect(iframe,iframe_parent,'instagram-embed-rendered');
            //iframe.parent('.instagram-embed-rendered').css('padding-bottom','calc(100% + 134px)');
          };
        });
      });
      */
    } else {
      iframe_aspect(iframe,iframe_parent,aspect);
    };
  });
  function iframe_aspect(iframe,iframe_parent,aspect,padding_bottom=null){
    if(iframe_parent.length>0) {
      iframe_parent.addClass('preserve-aspect '+aspect);
    } else if (iframe.parent().hasClass('preserve-aspect')) {
      // Don't do anything
    } else {
      if(!iframe.parent().hasClass('wp-block-embed__wrapper')) {
        iframe.wrap('<p class="preserve-aspect '+aspect+'"></p>');
      };
    };
    
  };
  /*
    $('#content .entry iframe').on('load', function() {
    console.log($(this).attr('src'));
    var iframe = $(this),
        iframe_contents = $(this).contents();
    
    // Wait for the iframe content to fully load
    iframe_contents.ready(function() {
      var iframe_height = iframe.height();
      var iframe_width = iframe.width();
      console.log((iframe_height-48)/iframe_width);
    });
  });  

  // Instagram Embed
  $('#content .entry .instagram-media').each(function(){
  	var instagram_parent = $(this).parent();
    if(!instagram_parent.hasClass('instagram')) {
      instagram_parent.addClass('instagram-embed instagram-loading');
    };  
  });
  */

  // External Links
  $('#content .article.external .content a').each(function(){
    var link = $(this);
    if(link.attr('href').indexOf("http") >= 0) {
		link.attr('target','_blank');
    };
  });
  
  // SMOOTH SCROLL
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && location.hostname == this.hostname) {
      if($(this.hash).length) {
        event.preventDefault();
      };
      // Update URL in address bar and scroll to anchor
      history.pushState(null, null, this.hash);
      globaljs.scrollTo(this.hash, event);
    };
  });
  globaljs.scrollTo = function(anchor_id,event=false) {
    var target = $(anchor_id);
    target = target.length ? target : $('[name=' + anchor_id.slice(1) + ']');
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      if(event) { event.preventDefault(); };
      $('html, body').animate({
        scrollTop: target.offset().top-150
      }, 250, function() {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        // $target.focus();
        if ($target.is(":focus")) { // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
          //$target.focus(); // Set focus again
        };
      });
    };
  };
  
  // SWATCHES
  $('.swatches.swatches-grid span').each(function(){
  	var swatch = $(this);
    
    if(swatch.attr('data-image')) {
      var swatch_img = swatch.parent().siblings('img'),
          swatch_a = swatch.closest('a'),
      	  swatch_href = swatch_a.attr('data-href');
      
      if(swatch.attr('data-image').split('?')[0] == swatch_img.attr('src').split('?')[0]) {
        swatch.addClass('active');
        //swatch_a.attr('href',swatch_href+'?variant='+swatch.attr('data-id'));
      };
      
      swatch.click(function(e){
        if(!swatch.hasClass('active')) {
		  swatch.siblings('span').removeClass('active');
          swatch.addClass('active');
          swatch_img.attr('src',swatch.attr('data-image'));  
          swatch_a.attr('href',swatch_href+'?variant='+swatch.attr('data-id'));
          e.preventDefault();
        };
      });
    };
  });
  
  // ADD TO CART
  $('.buysection .addtocart').click(function(e) {
    var addtocart = $(this),
        addtocart_id = $(this).attr('id').replace('addtocart-',''),
        variant_id = $("input[name='id']:checked").val(),
        variant_qty = $('#quantity-'+addtocart_id).val();

    e.preventDefault();
    addtocart.prop("disabled", true);
    addItem(addtocart_id);
  });
  function addItem(product_id) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#buysection-'+product_id).serialize(),
      product_id: product_id,
      success: addItemSuccess,
      error: addItemError
    });
  };  
  addItemSuccess = function(e) {
	var addtocart_message = $('#addtocart-message-'+e.product_id);
    $('#addtocart-'+e.product_id).removeAttr("disabled");
    addtocart_message.hide().fadeIn();

    var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
    var cartCount =  parseInt($('#cart-count').text()) + quantity;
    //$('#cart-count').text(cartCount);
  };
  addItemError = function(XMLHttpRequest, textStatus) {
        
    var data = JSON.parse(XMLHttpRequest.responseText);
    alert(data.description);
    
    $('.addtocart').removeAttr("disabled");
  };
  fullMessagesFromErrors = function(errors) {
    var fullMessages = [];
    jQuery.each(errors, function(attribute, messages) {
      jQuery.each(messages, function(index, message) {
        fullMessages.push(attribute + ' ' + message);
      });
    });
    return fullMessages;
  };
  // Quick Add to Cart
  $('.quickaddToggle').click(function(e){
    
    var quickaddID = $(this).attr('id').replace('quickaddToggle-',''),
        quickaddContent = $('#quickaddContent-'+quickaddID).html(),
        quickaddContentExpanded = $('#quickaddContentExpanded-'+quickaddID),
        quickaddSelect = $('select#productselect-'+quickaddID);
    
    $('#added-'+quickaddID).hide();
    
    quickaddContentExpanded.html(quickaddContent);
    quickaddSelect.on('change',function() {
      var variant = $(this).find('option:selected'),
          quickaddImage = quickaddContentExpanded.find('span.img img.image'),
          quickaddPrice = quickaddContentExpanded.find('small.subtitle.price');
      
      if(variant) {
        var variant_image = variant.attr('data-image'),
            variant_price = variant.attr('data-price');
        
        if(variant_price > 0) {
          variant_price = Shopify.formatMoney(variant_price, '')+' ';
          quickaddPrice.html(variant_price);
        };  

        if(variant_image) {
          quickaddImage.attr('src','');
          quickaddImage.attr('src',variant_image);
        };
      };
    });
    quickaddSelect.trigger('change');
  });
  $('.quickadd .addtocart').click(function(e){
    
    var addtocart = $(this),
        addtocart_id = $(this).attr('id').replace('addtocart-',''),
        variant_id = $('#productselect-'+addtocart_id+' option:selected').val(),
        variant_qty = $('#quantity-'+addtocart_id).val();
        
    if(addtocart.attr('data-iscart')) {
      window.location.href = '/cart/add?id='+variant_id+'&quantity='+variant_qty;
    } else {
      e.preventDefault();
      addtocart.prop("disabled", true);
      addItem(addtocart.attr('id').replace('addtocart-',''));
    };
  });
});